<template>


  <!-- 添加课程表单 -->
  <el-dialog
    v-model="editHotForm"
    title="调节热度"
    width="500"
    destroy-on-close
    center
  >
    <span>
      <div class="mb-3 row">
        <label for="hotValue" class="col-sm-2 col-form-label inputs"
          >热度值</label
        >
        <div class="col-sm-9">
          <div class="slider-demo-block">
            <el-slider v-model="hotValue" id="hotValue"/>
            <input type="hidden" id="courseId" :value="courseId">
          </div>
        </div>
        <div class="col-sm-1">
          <span style="color: red">*</span>
        </div>
      </div>
      <div class="mb-3 row">
        
        <label for="describes" class="col-sm-2 col-form-label"><span style="color: red">*</span>注:</label>
        <div class="col-sm-10">
          热度值大于0时, 将有机会进入首页成为推荐课程, 热度值越高越容易成为推荐课程!
        </div>
      </div>
    </span>
    <div></div>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="editHotForm = false">取消</el-button>
        <el-button type="button" @click="editHotOk()">
          提交
        </el-button>
      </div>
    </template>
  </el-dialog>




    <CateDrawerComponents  @selectCate='selectCate'/>


    <el-button icon="Search" style="float: right; margin: 5px;" @click="searchCourse()" circle />
    <input
    class="input-field"
    type="search"
    placeholder="课程名"
    id="keyword"
    style="float: right;"
  />


   <!-- 课程列表 -->
   <table class="table caption-top">
    <caption>
      全部课程
    </caption>
    <thead>
      <tr>
        <th scope="col">课程名称</th>
        <th scope="col">课程封面</th>
        <th scope="col">课程人数</th>
        <th scope="col">课程属性</th>
        <th scope="col">课程状态</th>
        <th scope="col">创建时间</th>
        <th scope="col">热度</th>
        <th scope="col">创建者</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="course in courseList" :key="course.courseId">
        <th scope="row" :title="course.courseName">{{ course.courseName.substr(0, 12) }}</th>
        <td>
          <img
            :src="course.courseImg"
            alt=""
            style="width: 140px; height: 70px"
          />
        </td>
        <td>{{ course.headCount }}</td>
        <td>
          <el-button type="success" v-if="course.isPublic == 0" plain
            >公开课</el-button
          >
          <el-tooltip :content="'加课码: 禁止查看'" placement="bottom">
            <el-button type="warning" v-if="course.isPublic == 1" plain
              >私有课</el-button
            >
          </el-tooltip>
        </td>
        <td>
          <el-popconfirm
            title="确定暂停课程吗？"
            @confirm="changeCourseState(course.states, course.courseId)"
            confirm-button-text="确认"
            cancel-button-text="取消"
            confirm-button-type="danger"
          >
            <template #reference>
              <el-button type="primary" v-if="course.states == 1" plain
                >开课中</el-button
              >
            </template>
          </el-popconfirm>

          <el-popconfirm
            title="确定恢复课程吗？"
            @confirm="changeCourseState(course.states, course.courseId)"
            confirm-button-text="确认"
            cancel-button-text="取消"
            confirm-button-type="danger"
          >
            <template #reference>
              <el-button type="info" v-if="course.states == 0" plain
                >暂停中</el-button
              >
            </template>
          </el-popconfirm>
        </td>
        <td>{{ course.createTime }}</td>
        <td>

          <el-button type="danger" v-if="course.isHot >= 1" @click="editHot(course.courseId, course.isHot);">
            <el-icon><TrophyBase /></el-icon>热度:{{ course.isHot }}</el-button>

          <el-button type="warning" v-if="course.isHot <= 0" @click="editHot(course.courseId, course.isHot);" plain>
            <el-icon><TrophyBase /></el-icon>热度:{{ course.isHot }}</el-button>
        </td>
        <td>
          <el-tooltip :content="'ID: ' + course.createId" placement="bottom">
          <el-button type="info" plain>
            {{ course.teacher.nickName }}
          </el-button> 
        </el-tooltip>
        </td>
      </tr>
    </tbody>
  </table>
  
  

    <nav aria-label="...">
    <ul class="pagination" style="float: center">
      <li class="page-item" @click="click_page(-2)">
        <a class="page-link" href="#">前一页</a>
      </li>
      <li
        :class="'page-item ' + page.is_active"
        v-for="page in pages"
        :key="page.number"
        @click="click_page(page.number)"
      >
        <a class="page-link" href="#">{{ page.number }}</a>
      </li>
      <li class="page-item" @click="click_page(-1)">
        <a class="page-link" href="#">后一页</a>
      </li>
    </ul>
  </nav>
  </template>
  
  <script setup>
  import { ref, onMounted,defineExpose } from "vue";
  import $ from "jquery";
  import { useRoute } from "vue-router";
  import router from "@/router/index";
  import {ElMessage} from 'element-plus';
  import CateDrawerComponents from "@/components/cate/CateDrawerComponents.vue";
  
  const courseList = ref([]);
  let current_page = 1;
  let current_cateId = 0;
  let current_courseName = '';
  let total_course = 0;
  let pages = ref([]);
  const Route = useRoute(); //获取到值
  const hotValue = ref(0);
  const courseId = ref("");
  const editHotForm = ref(false);
  
  onMounted(() => {
      // 获取路由参数并设置为 current_page
    current_page = parseInt(Route.params.page) || 1;
    current_cateId = parseInt(Route.params.cateId) || 0;
    current_courseName = Route.params.courseName || '';
  
    getAllCourse(current_page, current_cateId, current_courseName);
  });
  


  const selectCate = (id) => {
    getAllCourse(1, id, current_courseName);
  }

  
  const getAllCourse = (page, cateId, courseName) => {
  current_page = page;
  current_cateId = cateId;
  current_courseName = courseName;
  const token = localStorage.getItem("token");
    $.ajax({
      url: "http://124.222.105.205:5000/get/api/course/getAllCourse",
      data: {
        page: page,
        cateId: cateId,
        courseName: courseName
      },
      headers: {
      Authorization: "Bearer " + token,
    },
      type: "post",
      success(resp) {
        courseList.value = resp.data.list;
        total_course = resp.data.total;
        udpate_pages();
      },
      error() {},
    });
  };
  
  const click_page = (page) => {
      console.log("page:" + page);
    if (page === -2) page = current_page - 1;
    else if (page === -1) page = current_page + 1;
    let max_pages = parseInt(Math.ceil(total_course / 5));
    if (page >= 1 && page <= max_pages) {
      getAllCourse(page, current_cateId, current_courseName);
    }
  };
  
  const udpate_pages = () => {
    let max_pages = parseInt(Math.ceil(total_course / 5));
    let new_pages = [];
    for (let i = current_page - 2; i <= current_page + 2; i++) {
      if (i >= 1 && i <= max_pages) {
        new_pages.push({
          number: i,
          is_active: i === current_page ? "active" : "",
        });
      }
    }
    pages.value = new_pages;
    router.push({ name: "CourseAllView", params: { page: current_page, cateId: current_cateId , courseName: current_courseName} });
  };
  

  const changeCourseState = (state, id) => {
    const token = localStorage.getItem("token");
    $.ajax({
      url: "http://124.222.105.205:5000/api/course/updateStates",
      data: {
        states: state,
        id: id,
      },
      type: "post",
      headers: {
        Authorization: "Bearer " + token,
      },
      success(resp) {
        if (resp.code == "200") {
          ElMessage({
            type: "success",
            message: resp.msg,
          });
        } else {
          ElMessage({
            type: "error",
            message: resp.msg,
          });
        }

        getAllCourse(current_page, current_cateId, current_courseName);
      },
      error() {
        ElMessage({
          type: "error",
          message: "修改课程状态失败",
        });
      },
    });
  };

const searchCourse = () => {
  let courseName = $("#keyword").val();
  current_cateId = parseInt(Route.params.cateId) || 0;
  getAllCourse(1, current_cateId, courseName);
}


const editHot = (id, value) => {
    editHotForm.value = true;
    courseId.value = id;
    hotValue.value = value;
}

const editHotOk = () => {
  let id = $("#courseId").val();
  const token = localStorage.getItem("token");
  $.ajax({
    url: "http://124.222.105.205:5000/api/course/updateHotValue",
    data: {
      isHot: hotValue.value,
      courseId: id,
    },
    type: "post",
    headers: {
      Authorization: "Bearer " + token,
    },
    success(resp) {
      if (resp.code == "200") {
        ElMessage({
          type: "success",
          message: resp.msg,
        });
      } else {
        ElMessage({
          type: "error",
          message: resp.msg,
        });
      }
      editHotForm.value = false;
      getAllCourse(current_page, current_cateId, current_courseName);
    },
    error() {
      ElMessage({
        type: "error",
        message: "修改课程热度失败",
      });
      editHotForm.value = false;
    },
  });
};

  defineExpose({ getAllCourse });
  </script>
  
  <style scoped>

  .input-field {
      width: 300px; /* 输入框宽度 */
      padding: 5px;
      border: 1px solid #ccc; /* 边框样式 */
      border-radius: 5px; /* 边框圆角 */
      font-size: 16px; /* 字体大小 */
      outline: none; /* 去除默认轮廓 */
  }
  .input-field:hover,
  .input-field:focus {
      border-color: #66afe9; /* 修改边框颜色 */
      box-shadow: 0 0 5px rgba(102, 175, 233, 0.6); /* 添加阴影效果 */
  }
  </style>